import parser from 'ua-parser-js'

import ClassificationOfArticle from 'components/pages/Article/ClassificationOfArticle'
import MetaTags from 'components/pages/Article/ClassificationOfArticle/MetaTags'
import withLivingSinyi from 'utils/withLivingSinyi'
import withSafeServerSideProps from 'utils/server-utils/with-safe-server-side-props'
import NoindexRemoval from 'components/common/NoindexRemoval'
import { getArticleClassifications, getArticles } from 'utils/api'

const ClassificationOfArticlePage = (props) => {
  const { articleClassifications, articles, tabIndex } = props.fallbackData
  return (
    <>
      <NoindexRemoval />
      <MetaTags
        resolvedUrl={props.resolvedUrl}
        articleClassification={articleClassifications[tabIndex]}
        article={articles?.[0]}
      />
      <ClassificationOfArticle {...props} />
    </>
  )
}

export const getServerSideProps = withSafeServerSideProps(async (context) => {
  const { res } = context
  const ua = parser(context.req.headers['user-agent'])
  const isMobile = ['mobile', 'tablet'].includes(ua.device.type)
  const urlIdSource = context.params.classificationUrlId

  const [articleClassifications, error] = await getArticleClassifications()
  const [
    inVisibleArticleClassifications,
    _error,
  ] = await getArticleClassifications({ isVisible: false })

  // API 失敗 ≠ 分類不存在：停機時不可誤報 404，丟給 withSafeServerSideProps 分流
  if (error) {
    throw error
  }
  if (_error) {
    throw _error
  }
  const index = (articleClassifications || []).findIndex(
    (item) => item.urlId === urlIdSource
  )
  const _index = (inVisibleArticleClassifications || []).findIndex(
    (item) => item.urlId === urlIdSource
  )

  const [articles, articlesError] =
    index > -1
      ? await getArticles({
          articleClassificationIds: [articleClassifications[index]._id],
          limit: 20,
        })
      : [[]]

  if (index < 0) {
    if (_index < 0) {
      return { notFound: true }
    } else {
      res.setHeader('Cache-Control', 'max-age=300')

      return {
        redirect: {
          destination: '/article',
          permanent: true,
        },
      }
    }
  }

  if (articlesError) {
    // articles undefined 會在 SSR render 時 crash（500），丟給 withSafeServerSideProps 分流
    throw articlesError
  }

  return {
    props: {
      isMobile,
      fallbackData: {
        articleClassifications: articleClassifications || [],
        articles: articles ?? [],
        tabIndex: index,
      },
      resolvedUrl: context.resolvedUrl,
    },
  }
})

export default withLivingSinyi(ClassificationOfArticlePage)
